import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Card,
  CircularProgress,
  Alert
} from "@mui/material";
import DttTableData from '../../../components/DttTableData';
import { WorkshopAdminApi } from '../../../api/workshop-admin-api';
import type { GridSortDirection } from '@mui/x-data-grid';

export default function UsersManagement() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    WorkshopAdminApi.getListUser()
      .then((res) => {
        setRows(res.data ? res.data : []);
      })
      .catch(() => setError('Không lấy được danh sách user'))
      .finally(() => setLoading(false));
  }, []);

  const columns = [
    { field: 'user_login', headerName: 'Username', flex: 1 },
    { field: 'user_email', headerName: 'Email', flex: 1 },
    { field: 'display_name', headerName: 'Display name', flex: 1 },
    { field: 'role', headerName: 'Role', flex: 1 },
    { field: 'user_registered', headerName: 'Register date', flex: 1, valueGetter: (params: any) => new Date(params.value).toLocaleString() },
  ];

  // Sắp xếp mặc định theo ngày đăng ký mới nhất
  const sortModel = [
    { field: 'user_registered', sort: 'desc' as GridSortDirection },
  ];

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 2, px: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ fontWeight: 600 }}>
        User Management
      </Typography>
      <Card sx={{ p: 2 }}>
        {loading ? (
          <CircularProgress />
        ) : error ? (
          <Alert severity="error">{error}</Alert>
        ) : (
          <DttTableData
            columns={columns}
            rows={rows}
            loading={loading}
            buttonOptions={[]}
            onMenuClick={() => {}}
            sortModel={sortModel}
            hideSearchBox={false}
            checkboxSelection={false}
            disableRowSelectionOnClick={true}
            getRowId={(row: any) => row.user_login}
          />
        )}
      </Card>
    </Box>
  );
}
